import { defineStore } from 'pinia'
import { ref } from 'vue'

export const usePropertiesStore = defineStore(
  'properties',
  () => {
    const currentPropertyId = ref<number | undefined>()
    return { currentPropertyId }
  },
  {
    persist: {
      pick: ['currentPropertyId']
    }
  }
)
